import { PublicUrlUtils } from '@concretecode/shared';

export const envBaseUrl = (baseDomain: string): string => `https://${baseDomain}`;

export const envApiUrl = (baseDomain: string): string => `https://api.${baseDomain}`;

export const envBackofficeUrl = (baseDomain: string): string => `https://bo.${baseDomain}`;

export const envBackofficeRegisterUrl = (baseDomain: string): string => `https://bo.${baseDomain}/a/sign-up`;

export const envAppUrlWithoutSubdomain = (baseDomain: string): string => PublicUrlUtils.appUrlWithoutSubdomain(baseDomain);

export const envAppUrlWithSubdomain = (subdomain: string | undefined, baseDomain: string): string =>
  subdomain ? PublicUrlUtils.appUrlWithSubdomain(subdomain, baseDomain) : PublicUrlUtils.appUrlWithoutSubdomain(baseDomain);

export const envDemoUrl = (baseDomain: string): string => `https://demo.app.${baseDomain}`;

export const envUserContentBucketUrl = (baseDomain: string): string => `https://media.${baseDomain}`;
